import * as React from "react";
import Box from "@mui/material/Box";
import { keyframes } from "@emotion/react";
import Logo from "../../../images/portfolio-logo-white.png";

const slide = keyframes`
0%  { opacity: 0 }
100% { opacity: 1 }
`;

const LogoWhite = ({ isMenuVisible }) => {
  return (
    <Box
      component="img"
      sx={{
        opacity: "0",
        width: "110px",
        color: "white",
        outline: "white",
        text: "white",
        ...(isMenuVisible && {
          animation: `${slide} 2s forwards`,
        }),
      }}
      src={Logo}
      alt="portfolio image"
    ></Box>
  )
}

export default LogoWhite;
